import AppModal from '../../../common/components/CustomModal/AppModal';
import {Modules} from '@buncha/utils/types';
import {ShopperScreens} from '@buncha/home/navigation/types';
import React from 'react';
import {useColorThemeType} from '../../../appStyles/hooks/theme';
import {useGetLocale} from '@buncha/localization/hooks';

interface UnpackItemModalProps {
  open: boolean;
  onClose: Function;
  onSubmit: () => void;
  loading: boolean;
}

function UnpackItemModal(props: UnpackItemModalProps) {
  const {open, onClose, onSubmit, loading} = props;
  const theme = useColorThemeType();
  const {title, body, button} =
    useGetLocale(Modules.batchDetails, ShopperScreens.BatchDetailsPage) ?? {};
  return (
    <AppModal
      isOpen={open}
      onClose={() => onClose()}
      topCTAHandelr={onSubmit}
      title={title?.packAgain}
      subTitle={body?.packAgain}
      ctaBottomTitle={button?.cancel}
      ctaTopTitle={button?.unDrop}
      topCTAColor={theme?.background.green[100]}
      loading={loading}
    />
  );
}

export default React.memo(UnpackItemModal);
